import React from 'react'
import PropTypes from 'prop-types'
import { Card, Spinner, Text } from '@plurall/elo-beta'
import styles from './Loader.module.scss'

const Loader = ({ subTitle }) => (
  <div>
    <div className={styles.modal} />
    <div className={styles.container}>
      <Card>
        <div className={styles.body} role="dialog">
          <div className={styles.loading}>
            <Spinner size="large" />
          </div>

          <Text size="t1" semibold>
            Carregando...
          </Text>

          <Text size="t3" dimmed>
            {subTitle}
          </Text>
        </div>
      </Card>
    </div>
  </div>
)

Loader.defaultProps = {
  subTitle: 'Aguarde o carregamento',
}

Loader.propTypes = {
  subTitle: PropTypes.string,
}

export default Loader
